import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectorRef, Component, inject, type OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { hasServiceSync, userSelectedCompany$ } from '@auth/repository/auth.repository';
import { UME_SERVICE } from '@core/services/ume-services';
import { HOME_PAGE, PROVIDER } from '@shared/constants/ume-constants';

@UntilDestroy()
@Component({
  selector: 'ume-main-nav-wrap',
  styleUrls: ['main-nav-wrap.component.scss'],
  templateUrl: 'main-nav-wrap.component.html',
  imports: [RouterLink, NgOptimizedImage],
})
export class MainNavWrapComponent implements OnInit {
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public homepage?: string;

  ngOnInit(): void {
    userSelectedCompany$.pipe(untilDestroyed(this)).subscribe(() => {
      this.homepage = hasServiceSync(UME_SERVICE.PROVIDER)
        ? `${`${PROVIDER}/${HOME_PAGE}`}`
        : HOME_PAGE;
      this.cdr.markForCheck();
    });
  }
}
